import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PluginContextService } from '../../../core/services/plugin-context.service';
import { ArcAngelService } from '../../../core/services/arc-angel.service';
import { SessionOptionsService } from '../../../core/services/session-option.service';

import { OrganizationUtilService } from '../../../core/services/organization-util.service';

@Component({
  selector: 'app-eventupdateattributevisualizer',
  standalone: true,
  imports: [],
  templateUrl: './eventupdateattributevisualizer.component.html',
  styleUrl: './eventupdateattributevisualizer.component.css'
})
export class EventupdateattributevisualizerComponent implements OnInit, OnDestroy {
  @Input() entity!: string;

  mapEntity: any;
  updating = false;
  updatingVisibility = false;
  showButtons = false;

  private approvedInterval: any;
  private rejectedInterval: any;
  private publicInterval: any;
  private privateInterval: any;

  constructor(
    private pluginContext: PluginContextService,
    private arcAngelService: ArcAngelService,
    private sessionOptionsService: SessionOptionsService,
    private organizationutilService: OrganizationUtilService
  ) {}

  ngOnInit(): void {
    const entity = this.pluginContext.getDataContext().getMapEntity(this.entity);
    this.mapEntity = entity.arcLiveMapEntity;
    this.showButtons = this.sessionOptionsService.isLiveMode();

  }

  ngOnDestroy(): void {
    if (this.approvedInterval) clearInterval(this.approvedInterval);
    if (this.rejectedInterval) clearInterval(this.rejectedInterval);
    if (this.publicInterval) clearInterval(this.publicInterval);
    if (this.privateInterval) clearInterval(this.privateInterval);
  }

  approveUpdate(): void {
    this.updating = true;
    this.arcAngelService.approveIncidentUpdate(
      this.mapEntity.getEventId(),
      this.mapEntity.getData()
    ).then(() => {
      this.approvedInterval = setInterval(() => {
        if (this.mapEntity.getIsApproved()) {
          this.updating = false;
          clearInterval(this.approvedInterval);
        }
      }, 500);
    }).catch((err: any) => {
      this.updating = false;
    });
  }

  rejectUpdate(): void {
    this.arcAngelService.rejectIncidentUpdate(
      this.mapEntity.getEventId(),
      this.mapEntity.getData()
    ).then(() => {
      this.removeIncidentUpdateFrmBuilding(this.mapEntity.getData().id);
      this.mapEntity.setRejected();
    }).catch((err: any) => {
      this.updating = false;
    });
  }

  makePublic(): void {
    this.updatingVisibility = true;
    this.arcAngelService.publicizeIncidentUpdate(
      this.mapEntity.getEventId(),
      this.mapEntity.getData()
    ).then(() => {
      this.publicInterval = setInterval(() => {
        if (this.mapEntity.getIsPublic()) {
          this.updatingVisibility = false;
          clearInterval(this.publicInterval);
        }
      }, 500);
    }).catch((err: any) => {
      this.updatingVisibility = false;
    });
  }

  makePrivate(): void {
    this.updatingVisibility = true;
    this.arcAngelService.privitizeIncidentUpdate(
      this.mapEntity.getEventId(),
      this.mapEntity.getData()
    ).then(() => {
      this.privateInterval = setInterval(() => {
        if (this.mapEntity.getIsPrivate()) {
          this.updatingVisibility = false;
          clearInterval(this.privateInterval);
        }
      }, 500);
    }).catch((err: any) => {
      this.updatingVisibility = false;
    });
  }

  private removeIncidentUpdateFrmBuilding(incidentUpdateId: string): void {
    const buildings = this.organizationutilService.data.myBuildings || [];
    for (const building of buildings) {
      for (const incident of building.incidents || []) {
        const idx = incident.updates.findIndex((u: any) => u.data.id === incidentUpdateId);
        if (idx !== -1) {
          incident.updates.splice(idx, 1);
        }
      }
    }
  }
}